// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"cc2CsksbR6lv2Zq1eyJ6","collapseIcon":"HPh2iVvo2I4rfgzZF42G"};